import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const classApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const classSchema = v.object({
  ...classApiSchema.entries,
  ...optionSchema.entries,
});

export const classesApiSchema = paginatedSchema(classApiSchema);

export type ClassApi = v.InferOutput<typeof classApiSchema>;
export type ClassesApi = v.InferOutput<typeof classesApiSchema>;

export type ClassFilters = Filters<ClassApi>;

export type ClassFiltersUpdateApi = FiltersUpdateApi<ClassApi>;

export type Class = Prettify<Option<v.InferOutput<typeof classSchema>>>;

export type Classes = Entities<Class>;
